export default __webpack_public_path__ + "static/media/71.8525ba49.jpeg";